// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".h-info{color:#999;font-size:10px;top:1px;left:2px}.h-info:hover{color:#000}", ""]);
// Exports
module.exports = exports;
